export interface Resultaten {
  status: string,
  foutmelding: string,
  certList: CertList[]
}

export interface CertList {
  pdf_cert: string;
  xml_cert: string;
}
